import React, { forwardRef, useEffect, useState} from 'react';
import styled from 'styled-components';
import IEditableProps from 'src/utilities/IEditableProps';
import IStyledProps from 'src/utilities/IStyledProps';
import useLanguage from '../../utilities/useLanguage';
import { getTranslation } from './translations';
import classNames from 'classnames';
import BranchGoogleRatingService from "./BranchGoogleRatingService";
import GoldStar from "../../images/review-gold-star.png";
import GrayStar from "../../images/review-gray-star.png";
import GoogleLogo from "../../images/google-logo.svg";

export interface IBranchGoogleReviewProps extends IEditableProps, IStyledProps {
   branchCodeName: string;
}

export default styled(forwardRef(({className, editorClassObj, cmsId, branchCodeName}: IBranchGoogleReviewProps, ref: any) => {

   const { lang } = useLanguage();
   const translations = getTranslation(lang);
   const [rating, setRating] = useState(null);

   async function getResults() { 
      const result = await BranchGoogleRatingService.getGoogleRating(branchCodeName);
      console.log(result);
      setRating(result || null);
   }

   useEffect(() => {
      getResults()
   }, [branchCodeName]);

   return (
      <div className={classNames('', className, editorClassObj)} ref={ref} data-id={cmsId}>
         <div className="title">{translations.googleRating}</div>
         <div className="d-flex align-items-center">
            <img src={GoogleLogo} alt="Google Logo" className="google-logo d-block" width={48} height={48}/>
            <div className="">
               <div className="d-flex align-items-center">
                  <span className="rating">{rating ? rating.rating : 'N/A'}</span>
                  <div className="stars">
                     <div className="gold-stars" style={{width: `${rating ? rating?.rating * 100 / 5 : 0}%`}}></div>
                  </div>
               </div>
               <div className="d-flex">
                  {rating ? 
                     <a href={`https://search.google.com/local/reviews?placeid=${rating?.id}`} target='_blank' className='see-all'>{translations.seeAllOurReviews}</a>
                  : null}
               </div>
            </div>
         </div>
         
         
      </div>
   )
}))`
   border-width: 0;
   margin: auto 0 0;
   padding: 0.667rem 0;
   width: 100%;
   .title {
      color: #CE202E;
      font-family: 'National2 Narrow';
      font-size: 0.889rem;
      line-height: 1.5rem;
      font-weight: 500;
      text-transform: uppercase;
   }
   .google-logo {
      margin-right: 15px;
   }
   .rating {
      font-size: 1.444rem;
      font-family: "National2";
      font-weight: 700;
      line-height: 1.5rem;
      margin-right: 15px;
   }
   .stars {
      width: 105px;
      background: transparent url(${GrayStar}) left center repeat-x;
      position:relative;
      height: 17px;
      .gold-stars {
         position: absolute;
         top: 0;
         left: 0;
         display:block;
         height: 100%;
         background: transparent url(${GoldStar}) left center repeat-x;
      }
   }

   .see-all {
      font-size: 0.889rem;
      font-family: "National2";
      font-weight: 400;
      text-decoration: underline;
      color: #CF2031;
   }
   
   

`